import clsx from "clsx";


const Paper = ( props ) => (
    <div  {...props} className={clsx( "paper", props.className, {
        "elevation0": props.elevation === 0,
        "elevation2": props.elevation === 2,
        "elevation3": props.elevation === 3,
        "elevation4": props.elevation === 4,
        "elevation6": props.elevation === 6,
        "elevation8": props.elevation === 8,
        "elevation12": props.elevation === 12,
        "elevation16": props.elevation === 16,
        "elevation24": props.elevation === 24
    } )} />
)


export default Paper;

